// extracted by mini-css-extract-plugin
export default {"move-inspiration-modal-content":"index_move-inspiration-modal-content__aV+ie","mn-inspiration-image-modal":"index_mn-inspiration-image-modal__fReU6"};